import { v4 as uuidv4 } from 'uuid';

export const SUBSCRIPTION_STATUS = {
  expired: 'EXPIRED',
  canceled: 'CANCELED',
};

export const SUBSCRIPTION = {
  annual: 'annual',
  seasonal: 'seasonal',
  trial: 'trial',
  social: 'social',
};

export const PLAN_CODE = {
  fffsocial: 'fffsocial',
  ffftrial: 'ffftrial',
  fffvip: 'fffvip',
  fffvipa: 'fffvipa',
};

export const USER_ROLE = {
  club: 'CLUB',
  expired: 'EXPIRED',
};

export const getUserSubscriptionStatus = (subscriptionState) => {
  if (subscriptionState === 'ACTIVE') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'green',
    };
  }
  if (subscriptionState === 'EXPIRED') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'red',
    };
  }
  if (subscriptionState === 'CANCELED') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'grey',
    };
  }
  if (subscriptionState === 'CANCELLED_WITH_ZERO_BOXES') {
    return {
      SUBSCRIPTION_STATE: 'WILL NOT RENEW',
      COLOR: 'grey',
    };
  }
  return {
    SUBSCRIPTION_STATE: subscriptionState,
    COLOR: 'green',
  };
};

export const getUUID = () => {
  const isBrowser = () =>
    ![typeof window, typeof document].includes('undefined');
  const UUID_LOCAL_STORAGE_KEY = 'FFF_pandora_uuid';
  if (!isBrowser()) {
    return '';
  }
  const uuidFromLocalStorage =
    localStorage?.getItem(UUID_LOCAL_STORAGE_KEY) || null;
  if (!uuidFromLocalStorage && localStorage) {
    const uuid = uuidv4();
    localStorage.setItem(UUID_LOCAL_STORAGE_KEY, uuid);
    return uuid;
  }
  return uuidFromLocalStorage;
};
